import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("adminUsers", [], router);

export const adminUsersService = {
  ...baseService,
  listPaginated: (params) => api.getCall("/api/adminUsers/paginated", params),
};
